import { Box } from "@mui/material";

import { ClientSmartSearch } from "@/common/components/client-smart-search/ClientSmartSearch";
import { ClientsSearch } from "@/common/components/clients-search/ClientsSearch";
import UserDropdown from "@/common/components/user-dropdown/UserDropdown";

const APP_BAR_HEIGHT = 88;

export function Header() {
  return (
    <Box
      sx={{
        display: "flex",
        p: 3,
        gap: 1,
        height: `${APP_BAR_HEIGHT}px`,
        alignItems: "center",
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <ClientSmartSearch />
      </Box>
      <ClientsSearch />
      <UserDropdown />
    </Box>
  );
}
